export enum ThemePreferenceEnum {
  system = 'system',
  light = 'light',
  dark = 'dark',
}
